import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import * as React from 'react';

var SvgOliveAvatarPlaceholder = function SvgOliveAvatarPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    focusable: false
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M48 52c-8.837 0-16-7.163-16-16s7.163-16 16-16 16 7.163 16 16-7.163 16-16 16zm0 4c16 0 32 8.205 32 16.41V96H16V72.41C16 64.205 32 56 48 56z"
  }));
};

export default SvgOliveAvatarPlaceholder;